import React from 'react';

import './SectionThree.css';

type PropsType = {
  title?: string;
  children?: any;
};

const SectionThree = ({ title, children }: PropsType) => {
  return (
    <section className="tw-w-full tw-h-full tw-flex tw-flex-col">
      {title && <h1 className="oc-section-three-title">{title}</h1>}
      {children && <div className="oc-section-three-inner">{children}</div>}
    </section>
  );
};

export default SectionThree;
